import React from 'react';
import PropTypes from 'prop-types';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import MuiLink from '@material-ui/core/Link';

import { Link } from 'react-router-dom';

import { firstBy } from 'thenby';

// eslint-disable-next-line react/prop-types
const LinkItem = ({ label, value, route, theme = 'white' }) => {
  const link = props => <Link to={route} {...props} />;
  return (
    <div className={`link item ${theme}`}>
      <MuiLink
        title={label || value}
        component={React.forwardRef((props, ref) => link(props))}
        key={`summary-link-item-${label}`}
      >
        {label || value}
      </MuiLink>
    </div>
  );
};

// eslint-disable-next-line no-unused-vars
const CoverageBlock = ({ strings, loading, contract, frequency }) => {
  const { premiumsContract, covered_elements: coveredElements, is_loan: isLoan } = contract;

  let lastCovered = '';
  let newLine = false;
  // eslint-disable-next-line no-unused-vars, prefer-const
  let lastLoan = '';

  const sortedPremiums = Array.isArray(premiumsContract)
    ? premiumsContract.sort(
        firstBy((v1, v2) => {
          if (
            v1.option &&
            v2.option &&
            v1.option.coveredElement &&
            v2.option.coveredElement &&
            typeof v1.option.coveredElement.id !== 'undefined' &&
            typeof v2.option.coveredElement.id !== 'undefined'
          ) {
            return String(v1.option.coveredElement.id).localeCompare(String(v2.option.coveredElement.id));
          }
          return false;
        }, -1)
          .thenBy((v1, v2) => {
            if (v1.loan && v2.loan && typeof v1.loan.id !== 'undefined' && typeof v2.loan.id !== 'undefined') {
              return String(v1.loan.id).localeCompare(String(v2.loan.id));
            }
            return false;
          }, -1)
          .thenBy('recName')
      )
    : [];

  const hasParty = () => {
    let test = false;
    if (Array.isArray(coveredElements)) {
      coveredElements.forEach(coveredElement => {
        if (
          coveredElement &&
          coveredElement.party &&
          typeof coveredElement.party.id !== 'undefined' &&
          coveredElement.party.id !== null
        ) {
          test = true;
        }
      });
    }
    return test;
  };

  const getParty = id => {
    let party;
    if (Array.isArray(coveredElements)) {
      coveredElements.every(coveredElement => {
        if (
          coveredElement &&
          coveredElement.id === id &&
          coveredElement.party &&
          typeof coveredElement.party.id !== 'undefined' &&
          coveredElement.party.id !== null
        ) {
          // eslint-disable-next-line prefer-destructuring
          party = coveredElement.party;
          return false;
        }
        return true;
      });
    }
    return party;
  };

  const getFormatedCurrency = (amount, currencyFormat = 'fr-FR') =>
    new Intl.NumberFormat(currencyFormat, {
      style: 'currency',
      currency: 'EUR',
    }).format(amount);

  const getFormatedTotal = () => {
    let total = 0;
    sortedPremiums.forEach(premium => {
      total += premium.amount || 0;
    });
    return getFormatedCurrency(total);
  };

  const getCoveredElement = premium => {
    if (premium.option && premium.option.coveredElement) {
      const { coveredElement } = premium.option ? premium.option : {};
      let el;
      const { id, recName } = coveredElement;
      const party = getParty(id);
      if (lastCovered !== id) {
        el = recName;
        newLine = true;
      }
      lastCovered = id;
      return (
        <TableCell component="th" scope="row" className={el ? 'main' : 'slave'}>
          {el && hasParty() ? (
            <LinkItem label={recName} value={party ? party.id : id} route={`/party/${party ? party.id : id}`} />
          ) : (
            el
          )}
        </TableCell>
      );
    }
    return <TableCell component="th" scope="row" />;
  };

  const getLoan = loan => {
    let el;
    const { id, recName } = loan;
    if (lastLoan !== id) {
      el = id;
    }
    if (newLine) {
      lastLoan = id;
      newLine = false;
      return recName;
    }
    lastLoan = id;
    return el ? recName : el;
  };

  const getPremiumHeader = () => {
    const label = strings['contract.coverage.table.amount.label'] || 'Premium';
    let frequencyCode;
    try {
      let frequencyLabel;
      sortedPremiums.forEach(prem => {
        frequencyCode = prem.frequency ? prem.frequency : frequencyCode;
      });
      frequency.selection.forEach(freq => {
        frequencyLabel = freq[0] === frequencyCode ? freq[1] : frequencyLabel;
      });

      return (
        <>
          <div>{label}</div>
          <div>{frequencyLabel}</div>
        </>
      );
    } catch (error) {
      return undefined;
    }
  };

  //   const CoveredRisk = (columns, rows) => {
  // return (
  //   <Table className="table coverage">
  //   <TableHead>
  //     <TableRow>
  //       <TableCell>
  //          </TableRow>
  //         </TableHead>
  //         <TableBody>
  // )
  //   }

  return (
    <div className="coverage block">
      <Table className="table coverage">
        <TableHead>
          <TableRow>
            <TableCell>
              {hasParty()
                ? strings['contract.coverage.table.coveredPerson.label'] || 'Covered Person'
                : strings['contract.coverage.table.coveredElement.label'] || 'Covered Element'}
            </TableCell>
            {isLoan ? <TableCell>{strings['contract.coverage.table.loan.label'] || 'Loan'}</TableCell> : undefined}
            <TableCell>{strings['contract.coverage.table.coveredRisk.label'] || 'Covered Risk'}</TableCell>
            {!isLoan ? <TableCell>{getPremiumHeader()}</TableCell> : undefined}
          </TableRow>
        </TableHead>
        <TableBody>
          {Array.isArray(sortedPremiums)
            ? sortedPremiums.map((premium, idx) => (
                // eslint-disable-next-line react/jsx-indent
                <TableRow key={`${premium.recName}-${premium.amount}-${idx}`}>
                  {getCoveredElement(premium)}
                  {isLoan && premium.loan ? (
                    <TableCell component="th" scope="row">
                      {getLoan(premium.loan)}
                    </TableCell>
                  ) : undefined}
                  <TableCell component="th" scope="row">
                    {premium.recName}
                  </TableCell>
                  {!isLoan ? (
                    <TableCell component="th" scope="row">
                      {getFormatedCurrency(premium.amount)}
                    </TableCell>
                  ) : undefined}
                </TableRow>
              ))
            : undefined}
          {!isLoan ? (
            <TableRow key="premium.recName-premium.amount">
              <TableCell component="th" scope="row" />
              <TableCell component="th" scope="row" />
              <TableCell component="th" scope="row">
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                  }}
                >
                  <div
                    style={{
                      justifySelf: 'center',
                      alignSelf: 'flex-start',
                      color: 'rgba(0, 0, 0, 0.5)',
                    }}
                  >
                    {strings['contract.coverage.table.total.label'] || 'Total'}
                  </div>
                  <div
                    style={{
                      justifySelf: 'center',
                      alignSelf: 'flex-start',
                      fontWeight: 'bold',
                    }}
                  >
                    {getFormatedTotal()}
                  </div>
                </div>
              </TableCell>
            </TableRow>
          ) : undefined}
        </TableBody>
      </Table>
    </div>
  );
};

CoverageBlock.propTypes = {
  strings: PropTypes.objectOf(PropTypes.string),
  loading: PropTypes.objectOf(PropTypes.bool).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  contract: PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  frequency: PropTypes.object,
};

CoverageBlock.defaultProps = {
  strings: {},
  frequency: {
    name: 'frequency',
    string: 'Fréquence',
    selection: [
      ['yearly', 'Annuel (exact)'],
      ['yearly_360', 'Annuel (360 jours)'],
      ['yearly_365', 'Annuel (365 jours)'],
      ['half_yearly', 'Semestriel'],
      ['quarterly', 'Trimestriel'],
      ['monthly', 'Mensuel'],
      ['once_per_contract', 'Une fois par contrat'],
      ['once_per_invoice', 'Une fois par quittance'],
      ['once_per_year', 'Une fois par an'],
      ['at_contract_signature', 'A la signature du contrat'],
    ],
    type: 'selection',
  },
};
export default CoverageBlock;
